// extracted by mini-css-extract-plugin
export var btnBlock = "style-module--btn-block--af96e";
export var display = "style-module--display--5cafc";
export var display_footer = "style-module--display_footer--1c222";
export var display_neck = "style-module--display_neck--6b0d1";
export var display_wrapper = "style-module--display_wrapper--462d0";
export var education = "style-module--education--c1101";
export var education_colLeft = "style-module--education_col-left--d821e";
export var education_colLeftBg = "style-module--education_col-left--bg--5f8eb";
export var education_colRight = "style-module--education_col-right--c35a7";
export var education_colRightText = "style-module--education_col-right--text--feafd";
export var education_row = "style-module--education_row--6332e";
export var tab = "style-module--tab--43fea";
export var tabs = "style-module--tabs--d8e4b";
export var wrapper = "style-module--wrapper--8da35";